import {useEffect} from 'react';
import {useQueryClient} from '@tanstack/react-query';
import {getBootstrapData} from '@common/core/bootstrap-data/use-backend-bootstrap-data';
import {PublicDocArticle} from '@app/docs/use-public-documentation';

function hydrateFromBootstrap(queryClient: ReturnType<typeof useQueryClient>) {
  const loader = getBootstrapData()?.loaders?.publicDocs;
  if (!loader) {
    return;
  }

  if (loader.catalog && queryClient.getQueryData(['documentation']) == null) {
    queryClient.setQueryData(['documentation'], loader.catalog);
  }

  const articles = loader.articles as
    | Record<string, PublicDocArticle>
    | undefined;
  if (!articles) {
    return;
  }

  for (const [slug, article] of Object.entries(articles)) {
    if (queryClient.getQueryData(['documentation', slug]) == null) {
      queryClient.setQueryData(['documentation', slug], article);
    }
  }
}

/** Прогревает react-query из bootstrap, чтобы переходы по /docs не мигали. */
export function useHydratePublicDocsCache() {
  const queryClient = useQueryClient();
  // Синхронно: иначе Node SSR рисует пустую статью / 404 до useEffect.
  // Изменено: 2026-08-27.
  hydrateFromBootstrap(queryClient);

  useEffect(() => {
    hydrateFromBootstrap(queryClient);
  }, [queryClient]);
}
